import React,{useState} from 'react'
import {Dialog,DialogTitle} from '@mui/material';
import './DialogComp.css';
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";

const DialogComp = ({handleClickOpen,handleClose,open}) => {

    const [openDate, setOpenDate] = useState(false);
    const [date, setDate] = useState([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
      const [openOptions, setOpenOptions] = useState(false);
      const [options, setOptions] = useState({
        adult: 1,
        children: 0,
        room: 1,
      });
        
      const handleOption = (name, operation) => {
        setOptions((prev) => {
          return {
            ...prev,
            [name]: operation === "i" ? options[name] + 1 : options[name] - 1,
          };
        });
      };
    

    return (
        <Dialog onClose={handleClose} open={open} className='dialogMain'>
        <DialogTitle>Filter</DialogTitle>
        <div style={{padding:'20px',paddingTop:'0px'}} className='dialogDiv'>
        <hr className='dialogHr' />
        <p style={{color:'black',textAlign:'left'}} className='dialogCompLoc' >Location</p>
                <input
                  type="text"
                  placeholder="Where are you going?"
                  className="dialogCompInput"
                //   onChange={(e) => setDestination(e.target.value)}
                />
                 <div style={{display:'flex',flexDirection:'column'}}>
                <span style={{color:'black',textAlign:'left'}}>Check in - Check out</span>
                <span
                  onClick={() => setOpenDate(!openDate)}
                  className="dialogCompDate"
                >{`${format(date[0].startDate, "MM/dd/yyyy")} - ${format(
                  date[0].endDate,
                  "MM/dd/yyyy"
                )}`}</span>
                {openDate && (
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => setDate([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={date}
                    className="dialogCal"
                    minDate={new Date()}
                  />
                )}
                </div>

                <p style={{color:'black',textAlign:'left',marginBottom:0}}>Guests</p>

                <span
                  onClick={() => setOpenOptions(!openOptions)}
                  className="dialogCompList"
                >{`${options.adult} adult · ${options.children} children · ${options.room} room`}</span>
                {openOptions && (
                  <div className="options">
                    <div className="optionItem">
                      <span className="optionText">Adult</span>
                      <div className="optionCounter">
                        <button
                          disabled={options.adult <= 1}
                          className="optionCounterButton"
                          onClick={() => handleOption("adult", "d")}
                        >
                          -
                        </button>
                        <span className="optionCounterNumber">
                          {options.adult}
                        </span>
                        <button
                          className="optionCounterButton"
                          onClick={() => handleOption("adult", "i")}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="optionItem">
                      <span className="optionText">Children</span>
                      <div className="optionCounter">
                        <button
                          disabled={options.children <= 0}
                          className="optionCounterButton"
                          onClick={() => handleOption("children", "d")}
                        >
                          -
                        </button>
                        <span className="optionCounterNumber">
                          {options.children}
                        </span>
                        <button
                          className="optionCounterButton"
                          onClick={() => handleOption("children", "i")}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="optionItem">
                      <span className="optionText">Room</span>
                      <div className="optionCounter">
                        <button
                          disabled={options.room <= 1}
                          className="optionCounterButton"
                          onClick={() => handleOption("room", "d")}
                        >
                          -
                        </button>
                        <span className="optionCounterNumber">
                          {options.room}
                        </span>
                        <button
                          className="optionCounterButton"
                          onClick={() => handleOption("room", "i")}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                )}



</div>
      </Dialog>
        )

}

export default DialogComp